<template>
  <body id="body" class="main-body">
    <script2 async src="https://cdn.ampproject.org/v0.js"></script2>
    <!-- モバイル用モーダル画面 -->
    <b-modal :active.sync="isModalImage" animation="zoom-out">
      <p class="image is-4by3">
        <img style="object-fit: contain;" :src="tempImage">
      </p>
    </b-modal>
    <div class="modal-mask" v-if="isMyName&&!isStoryLoading&&isCompletedStory&&!isImageLoading&&!lastView"></div>
    <transition name="slide-bottom">
      <div class="modal-myname" v-if="isMyName&&!isStoryLoading&&isCompletedStory&&!isImageLoading&&!lastView">
        <p style="font-weight: 600; margin-bottom: 8px;">主人公のお名前を入力して下さい</p>
        <input style="margin-bottom: 8px;" class="input" v-model="inputMyName"/>
        <div style="display: flex;">
          <button class="button is-primary is-fullwidth" style="min-width: 120px; margin-right:20px;" @click="isMyName=false" :disabled="!inputMyName">スタート</button>
          <button class="button is-fullwidth" style="min-width: 120px;" @click="inputMyName='あなた';isMyName=false">指定なし</button>
        </div>
      </div>
    </transition>
    <div class="vertical">
      <transition name="slide-top">
        <div class="header-recruit" v-if="isTitle && !isImageLoading">
          <img class="title-image" :src="getBackgroundStory(story)" v-if="story"/>
          <div class="title-box" v-if="story">
            <p id="title">{{story.title}}</p>
            <p class="sub-title" v-if="story.writer == 'client'">{{story.company_name}}</p>
            <p class="sub-title" v-else-if="story.writer == 'user'">{{story.user_name}}</p>
          </div>
        </div>
      </transition>
      <div class="flex-container" id="chat">
        <transition name="init-anime"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:after-enter="afterEnter"
          v-on:enter-cancelled="enterCancelled"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
          v-on:after-leave="afterLeave"
          v-on:leave-cancelled="leaveCancelled">
          <div class="start-container" v-show="isStoryLoading||isImageLoading">
            <div class="start-box" v-for="i in 2" :key="i">
              <img class="background-scene not-copy" :src="getBackgroundImage(i)"/>
              <div class="balloon-list not-copy" v-for="j in 6" :key="j">
                <div class="bln-box not-copy" :class="{'my-speaker': j%2 === 0}">
                  <img src="@/assets/character/4_female.png" v-if="j%2 === 0"/>
                  <img src="@/assets/character/8_male.png" v-if="j%2 === 1"/>
                  <div class="message-box">
                    <p class="name" style="color: transparent;">name</p>
                    <p class="message" style="width: 150px; height: 36px;" :id="'textarea-bln' + j"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <!-- チャット画面 -->
        <transition name="fade">
          <div class="main-container" @scroll="handleScroll" @click="nextDialog()" @mousedown="startPush" @touchstart="startPush" @mouseup="finishPush" @touchend="finishPush" v-if="!isStoryLoading&&isCompletedStory&&!isImageLoading">
            <div :id="'scene-'+si" class="scene-container" v-for="(s, si) in scenes" :key="si" v-if="scenes.length > 0 && openScene >= si">
              <img class="background-scene not-copy" :src="getBackgroundScene(scenes[si])"/>
                <!-- プッシュ通知 -->
              <transition name="news">
                <div class="news-container" v-if="isModal">
                  <div class="news-img">
                    <img :src="getIconNews(isNewsIcon)">
                  </div>
                  <div class="news-title">
                    <p>{{isNewsTitle}}</p>
                  </div>
                  <div class="news-text">
                    <p>{{isNewsText}}</p>
                  </div>
                </div>
              </transition>
              <transition name="news">
                <div class="news-container2" v-if="isModal2">
                  <div class="news-img">
                    <img :src="getIconNews(isNewsIconPre)">
                  </div>
                  <div class="news-title">
                    <p>{{isNewsTitlePre}}</p>
                  </div>
                  <div class="news-text">
                    <p>{{isNewsTextPre}}</p>
                  </div>
                </div>
              </transition>
              <!-- 続きから確認 -->
              <div v-if="idxRead == -1 && lastView" class="last-view">
                以前にこのノベルを途中まで読んでいます。<br>続きから開始しますか？
                <div class="menu-btn-container space-top16 last-view-button" style="left: 0%;">
                  <button  @click.stop="lastView=null" class="menu-btn button">最初から読む</button>
                </div>
                <div class="menu-btn-container space-top16 last-view-button" style="left: 100%">
                  <button @click.stop="skipToLastView()" class="menu-btn button">続きから読む</button>
                </div>
              </div>
              <div class="balloon-list not-copy" v-if="storyDialog.length > 0" @scroll="handleScrollScene(si)">
                <div :id="'novel-scroll-' + si"></div>
                <div v-for="(d, di) in storyDialog" :key="di" v-if="idxRead >= di && s.pk == d.scene">
                  <!-- Status: 0 会話 -->
                  <div class="bln-box not-copy" :class="{'my-speaker': d.character == scenes[si].main_character}" v-if="d.status == 0">
                    <img :src="getIconCharacterFromDialog(d.character)"/>
                    <div class="message-box">
                      <p class="name">{{getCharacterName(d.character)}}</p>
                      <p class="message" :id="'textarea-bln' + di">{{d.content}}
                        <a class="button is-small" style="margin-right: 8px;" :href="url" v-for="(url, ui) in getUrllist(d.content)" :key="ui" target="_blank" v-if="getUrllist(d.content)" @mouseover="isOver=true" @mouseleave="isOver=false">
                          <span class="mdi mdi-link-variant" style="margin-right: 8px;"></span>リンク {{ui+1}} へ
                        </a>
                      </p>
                    </div>
                  </div>
                  <!-- Status: 1 タイトル -->
                  <div class="bln-box not-copy" v-if="d.status == 1">
                    <div class="message-box-title">
                      <p 
                      :id="'textarea-title' + di"
                      :class="[
                        {'font-color-black'  : d.title_color    == 'black'},
                        {'font-color-white'  : d.title_color    == 'white'},
                        {'font-color-red'    : d.title_color    == 'red'},
                        {'font-color-orange' : d.title_color    == 'orange'},
                        {'font-color-yellow' : d.title_color    == 'yellow'},
                        {'font-color-green'  : d.title_color    == 'green'},
                        {'font-color-skyblue': d.title_color    == 'skyblue'},
                        {'font-color-blue'   : d.title_color    == 'blue'},
                        {'font-color-purple' : d.title_color    == 'purple'},
                        {'bg-color-black'    : d.title_bg_color == 'black'},
                        {'bg-color-white'    : d.title_bg_color == 'white'},
                        {'bg-color-red'      : d.title_bg_color == 'red'},
                        {'bg-color-orange'   : d.title_bg_color == 'orange'},
                        {'bg-color-yellow'   : d.title_bg_color == 'yellow'},
                        {'bg-color-green'    : d.title_bg_color == 'green'},
                        {'bg-color-skyblue'  : d.title_bg_color == 'skyblue'},
                        {'bg-color-blue'     : d.title_bg_color == 'blue'},
                        {'bg-color-purple'   : d.title_bg_color == 'purple'},
                        {'font-small'        : d.title_size     == '小'},
                        {'font-medium'       : d.title_size     == '中'},
                        {'font-large'        : d.title_size     == '大'},
                      ]">{{d.content}}</p>
                      <div style="width: 100%; margin-top: 8px; display: flex; justify-content: center;" @mouseover="isOver=true" @mouseleave="isOver=false">
                        <a class="button is-small" style="margin-right: 8px;" :href="url" v-for="(url, ui) in getUrllist(d.content)" :key="ui" target="_blank" v-if="getUrllist(d.content)">
                          <span class="mdi mdi-link-variant" style="margin-right: 8px;"></span>リンク {{ui+1}} へ
                        </a>
                      </div>
                    </div>
                  </div>
                  <!-- Status: 2 画像 -->
                  <div class="bln-box not-copy" :class="{'my-speaker': d.character == scenes[si].main_character, 'no-speaker': !d.character}" v-if="d.status == 2">
                    <img :src="getIconCharacterFromDialog(d.character)" v-if="d.character"/>
                    <div class="message-box" @mouseover="isOver=true" @mouseleave="isOver=false">
                      <p class="name">{{getCharacterName(d.character)}}</p>
                      <amp-img class="message-box-image" @click="openImage(d.store_image)" width="70" height="50" layout="responsive" :src="d.store_image" v-if="d.store_image"></amp-img>
                      <amp-img class="message-box-image" @click="openImage(d.image)" width="70" height="50" layout="responsive" :src="d.image" v-else-if="d.image"></amp-img>
                      <div class="no-image" v-else>
                        画像が設定されていません。
                      </div>
                    </div>
                  </div>
                  <!-- Status: 3 電話 -->
                  <div class="bln-box not-copy" :class="{'my-speaker': d.character == scenes[si].main_character}" v-if="d.status == 3">
                    <img :src="getIconCharacterFromDialog(d.character)"/>
                    <div class="message-box">
                      <p class="name">{{getCharacterName(d.character)}}</p>
                      <div class="phone-box">
                        <p><span :class="phoneImage[d.phone_type]"></span></p>
                        <p>{{phoneTypes[d.phone_type]}}</p>
                      </div>
                    </div>
                  </div>
                  <!-- Status: 4 次の話へ -->
                  <div class="bln-box not-copy" v-if="d.status == 4">
                    <div class="next-box" @mouseover="isOver=true" @mouseleave="isOver=false" v-if="nextPubStory.length > 0 && !isGetPubStory">
                      <amp-img class="next-img" width="300" height="150" layout="responsive" :src="getBackgroundStory(getNextPub(d, 1))"></amp-img>
                      <p style="font-weight: 600; margin-bottom: 8px;">次の求人ノベルを読む</p>
                      <a class="button is-primary" :href="'/recruits/story/' + story.company_id + '/' + d.content">{{getNextPub(d, 0)}}へ</a>
                    </div>
                    <div style="width: 100%; height: 150px;" v-else>
                      <span class="mdi mdi-loading mdi-spin mdi-24px"></span>
                    </div>
                  </div>
                  <!-- Status: 5 動画 -->
                  <div class="bln-box not-copy" :class="{'my-speaker': d.character == scenes[si].main_character}" v-if="d.status == 5">
                    <img :src="getIconCharacterFromDialog(d.character)"/>
                    <div class="message-box">
                      <p class="name">{{getCharacterName(d.character)}}</p>
                      <div class="movie-container">
                        <iframe v-if="d.movie_url&&d.movie_url!=''" width="240" height="135" :src="d.movie_url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <video v-else-if="d.store_movie" :src="d.store_movie" controls width="240" height="135"><p>動画を再生するにはサポートされたブラウザが必要です。</p></video>
                        <video v-else-if="d.movie" :src="d.movie" controls width="240" height="135"><p>動画を再生するにはサポートされたブラウザが必要です。</p></video>
                        <div v-else class="no-image" width="240" height="135">動画が設定されていません。</div>
                      </div>
                    </div>
                  </div>
                  <!-- Status: 7 クイズ -->
                  <div class="quiz-box not-copy" v-if="d.status == 7">
                    <!-- 解答者情報入力モーダル：最初のみ -->
                    <div style="position: fixed; width: 100%; height: 100%; top: 0px; left: 0px; z-index: 100; background-color: rgba(0,0,0,0.3);" v-if="!quizRespondent"></div>
                    <div class="modal-respondent" style="z-index: 101;" v-if="!quizRespondent">
                      <p style="font-weight: 600; margin-bottom: 8px;">クイズ回答集計にご協力ください</p>
                      <input style="margin-bottom: 8px;" class="input" v-model="inputQuizResName" placeholder="お名前"/>
                      <div style="display: flex;">
                        <button class="button is-primary is-fullwidth" style="min-width: 120px; margin-right:20px;" @click="setRespondent(true)" :disabled="!inputQuizResName">送信</button>
                        <button class="button is-fullwidth" style="min-width: 120px;" @click="setRespondent(false)">入力しない</button>
                      </div>
                    </div>
                    <!-- 会話本体 -->
                    <div class="quiz-question">
                      <p :id="'textarea-quiz' + di">{{d.content}}</p>
                      <div v-for="(seq, seqi) in d.sequence" :key="seqi">
                        <button :class="['quiz-choice', seq==0 ? 'quiz-collect' : 'quiz-incollect', {'quiz-select': seq==d.select}]"
                        @click.stop="clickQuizChoice(seq)" :disabled="d.select!=null">
                          <p class="sign">{{"ABCDEFGHIJ".substr(seqi,1)}}</p>
                          <p class="statement">{{d.quiz_choices[seq]}}</p>
                        </button>
                      </div>
                    </div>
                    <div class="quiz-question" v-if="d.select!=null">
                      <div v-if="d.select==0">正解です！</div>
                      <div v-if="d.select!=0">残念、不正解です</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- タップ用空白 -->
              <div class="tap-navi not-copy">
                <!-- <div :style="nextNavi()"></div> -->
                <button class="button is-small is-primary auto-button" @click="isAutomatic=false" v-if="isAutomatic&&!isFinished"><span class="mdi mdi-spin mdi-autorenew" style="margin-right: 8px;"></span>自動進行 ON</button>
                <button class="button is-small auto-button" @click="isAutomatic=true"  v-if="!isAutomatic&&!isFinished"><span class="mdi mdi-autorenew" style="margin-right: 8px;"></span>自動進行 OFF</button>
                <div class="huyuu" v-if="(idxRead < 3 || isNavi) && !isFinished">
                  <span class="mdi mdi-gesture-double-tap mdi-48px"></span>
                </div>
                <p v-if="(idxRead < 3 || isNavi) && !isFinished">タップ/クリックをすることで次へ進みます。<br>長押しで自動進行モードに変わります。</p>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- いいね！ -->
      <div class="finished-container">
        <div id="finished" class="share-container" v-if="isFinished">
          <div class="thanks-message">
            <p>最後までお読みいただきありがとうございました。</p>
            <p>求人ノベルが面白かったと感じていただいた場合は、いいね！・シェアをお願い致します。</p>
          </div>
          <div class="evaluate-btn-container">
            <div class="button good-button" @click="createGVStory()">
              <p v-if="!isAlreadyGood"><span class="mdi mdi-heart"></span></p>
              <p v-if="isAlreadyGood" style="font-size: 18px;"><span class="mdi mdi-heart"></span></p>
              <p v-if="!isAlreadyGood">いいね！</p>
              <p v-if="isAlreadyGood" style="font-size: 11px; color: #444;">いいね！済</p>
            </div>
            <div v-if="$isUser()">
              <p class="delete-follow-btn" v-if="followState===true" @click="deleteFollow()">フォロー中</p>
              <p class="add-follow-btn" v-else-if="followState===false" @click="addFollow()">フォローする</p>
            </div>
          </div>
          <div class="share-box">
            <a style="margin-right: 8px;" target="_blank" rel="noopener" :href="getFaceBookUrl(c)">
              <img style="height: 32px; width: 32px;" src="@/assets/template/facebook_logo.png"/>
            </a>
            <a style="margin-right: 8px;" target="_blank" rel="noopener" :href="getLineUrl(c)">
              <img style="height: 32px; width: 32px;" src="@/assets/template/line_logo.png"/>
            </a>
            <a target="_blank" rel="noopener" :href="getTwitterUrl(c)">
              <img style="height: 32px; width: 32px;" src="@/assets/template/twitter_logo.png"/>
            </a>
          </div>
        </div>
        <article v-if="isFinished">
          <div class="top-wrapper" v-if="story.writer == 'client'">
            <div class="menu-btn-container space-top16">
              <button @click="isModalActive(0)" class="menu-btn button" disabled v-if="isClient == true">話を聞きにいきたい</button>
              <button @click="isModalActive(0)" class="menu-btn button" v-else>話を聞きにいきたい</button>
            </div>
            <div class="menu-btn-container space-top16">
              <button @click="isModalActive(1)" class="menu-btn button">読了報告</button>
            </div>
            <div class="menu-btn-container space-top16">
              <button @click="isModalActive(2)" class="menu-btn button">質問する</button>
            </div>
          </div>
          <div class="bottom-wrapper">
            <div class="menu-btn-container space-top16">
              <button class="menu-btn button" disabled v-if="isClient == true">保存する</button>
              <button @click="isModalActive()" class="menu-btn button"  v-else-if="isClient == false && isUser == false"  >保存する</button>
              <button @click.once="postStoryProfileFavorite" class="menu-btn button" v-else>保存する</button>
            </div>
            <div class="menu-btn-container space-top16">
              <button @click="linkOfficialHp" v-if="story.writer == 'client'" class="menu-btn button">公式ページ</button>
              <!-- comment: ロボの中に公式ページという動線 -->
              <!-- <iframe width="320" height="300" src="https://ndr-demo-page.firebaseapp.com/stg/dest/joinus/"/> -->
            </div>
            <div class="menu-btn-container space-top16">
              <button @click="writeNovel" class="menu-btn button">ノベルを書く</button>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- この会社の別のノベルを読む -->
    <div class="anotherNovel" v-if="isFinished && otherStories.length > 0">
      <h1>この会社の別のノベルを読む</h1>
      <a v-for="(s, index) in otherStories"
        :key="index"
        :href="'/recruits/story/' + s.company_id + '/' + s.story_id"
        class="novel-card"
        :class="{'active':index==0}">
        <div class="img-icon"><img :src="getBackgroundStory(s)"/></div>
        <section>
          <div class="novel-title">{{s.title}}</div>
          <div class="novel-company">{{story.company_name}}</div>
          <div class="novel-tags-container">
            <div v-for="(t, i) in tagsList(s.tags)" :key=i class="tag is-small novel-tag">
              {{t}}
            </div>
          </div>
          <div class="novel-create"><p>{{new Date(s.updated_at).toLocaleString('ja-JP')}}</p></div>
          <div class="novel-count" style="display: flex; justify-content: flex-start; align-items: center; margin-top: 4px; ">
            <p style="margin-left: 8px; margin-right: 8px;"><span class="mdi mdi-eye"></span> {{s.pv_count}}</p>
            <p style="color: red;"><span class="mdi mdi-heart"></span> {{s.gv_count}}</p>
          </div>
        </section>
      </a>
    </div>
    <!-- あなたへのレコメンド -->
    <!-- 求人ノベル掲載する会社増えて来たら、追加する -->
    <!-- <div id="finished" class="anotherNovel"  v-if="isFinished && companyNovel.length > 0">
      <h1>あなたへのレコメンド</h1>
      <a v-for="(s, index) in otherStories"
        :key="index"
        :href="'/recruits/story/' + s.company_id + '/' + s.story_id"
        class="novel-card"
        :class="{'active':index==0}">
        <div class="img-icon"><img :src="getBackgroundStory(s)"/></div>
      <div class="novel-title">{{s.title}}</div>
      <div class="novel-company">{{story.company_name}}</div>
      <div class="novel-create"><p>{{new Date(s.updated_at).toLocaleString('ja-JP')}}</p></div>
      <div class="novelCount" style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 4px;">
          <p style="margin-left: 8px; margin-right: 8px;"><span class="mdi mdi-eye"></span> {{s.pv_count}}</p>
          <p style="color: red;"><span class="mdi mdi-heart"></span> {{s.gv_count}}</p>
        </div>
      </a>
    </div> -->
    <!-- 話を聞きに行きたい -->
    <b-modal v-if="isUser == true && applicationType == 0" :width="600" :active.sync="isModalFlg">
      <div class="card">
        <div v-if="!wantToMeetFlg">
          <p class="entry">エントリーしますか？</p>
          <div class="button-wrapper">
            <button @click="closeModal" class="button">いいえ</button>
            <button @click.once="userStoryAction()" class="button is-primary">はい</button>
          </div>
        </div>
        <div v-if="wantToMeetFlg">
          <p class="entry-msg">エントリーしました！</p>
          <div class="entry-sub-msg">*確認メールを送付いたしました。ご確認の程よろしくお願いいたします。</div>
        </div>
      </div>
    </b-modal>
    <!-- 読了報告 -->
    <b-modal v-if="isUser == true && applicationType == 1 || isClient == true && applicationType == 1" :width="600" :active.sync="isModalFlg">
      <div class="card">
        <p class="finish-reading">読了報告</p>
        <div v-if="!nextFinishReadingFlg && !sendFinishReadingFlg">
          <div>
              <textarea v-model="finishReadingReport" maxlength="200" class="finish-reading-textarea textarea" placeholder="報告内容を入力"></textarea>
          </div>
          <div>
            <button @click="nextFinishReadingFlg = true" class="button is-fullwidth is-primary">次へ</button>
          </div>
        </div>
        <div v-if="nextFinishReadingFlg && !sendFinishReadingFlg">
          <p class="confirm-sentence">以下の内容でお間違えなければ、送信ボタンを押してください。</p>
          <div>
              <div class="finish-reading-textarea">{{finishReadingReport}}</div>
          </div>
          <div class="button-container">
            <div>
              <button @click="nextFinishReadingFlg = false" class="button">内容を修正する</button>
            </div>
            <div>
              <button @click.once="sendFinishReading" class="button is-primary">送信</button>
            </div>
          </div>
        </div>
        <div v-if="sendFinishReadingFlg">
          <p>読了報告を送信しました。</p>
        </div>
      </div>
    </b-modal>
    <!-- 質問する -->
    <b-modal v-if="isUser == true && applicationType == 2 || isClient == true && applicationType == 2" :width="600" :active.sync="isModalFlg">
      <div class="card">
        <p class="finish-reading">質問する</p>
        <div v-if="!nextQuestionFlg && !sendQuestionFlg">
          <div>
              <textarea v-model="question" maxlength="200" class="finish-reading-textarea textarea" placeholder="質問内容を入力"></textarea>
          </div>
          <div>
            <button @click="nextQuestionFlg = true" class="button is-fullwidth is-primary">次へ</button>
          </div>
        </div>
        <div v-if="nextQuestionFlg && !sendQuestionFlg">
          <p class="confirm-sentence">以下の内容でお間違えなければ、送信ボタンを押してください。</p>
          <div>
              <div class="finish-reading-textarea">{{question}}</div>
          </div>
          <div class="button-container">
            <div>
              <button @click="nextQuestionFlg = false" class="button">内容を修正する</button>
            </div>
            <div>
              <button @click.once="sendQuestion" class="button is-primary">送信</button>
            </div>
          </div>
        </div>
        <div v-if="sendQuestionFlg">
          <p>質問を送信しました。</p>
        </div>
      </div>
    </b-modal>
    <b-modal v-if="isUser == false && isClient == false" :width="400" :active.sync="isModalFlg">
      <div class="card">
        <p class="logo-img-wrapper"><img src="@/assets/lp/logo_blue.svg" alt="タイトル"></p>
        <p class="need-login-msg">このサービスを利用するには、HRmonsterに登録またはログインしていただく必要があります。</p>
        <div>
          <div class="login-btn-wrapper">
            <router-link to="/login" class="button is-fullwidth is-primary">ログインする</router-link>
          </div>
          <div class="create-account">
            <router-link class="button is-fullwidth" to="/create_user">アカウントをお持ちでない方</router-link>
          </div>
        </div>
      </div>
    </b-modal>
  </body>
</template>

<script>
import { mapState } from 'vuex'
import Loading from '@/components/animations/Loading'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import session from '@/api/session'
import createUUID from '@/functions/createUUID'

export default {
  name: 'StoryView',
  componentName: 'StoryView',
  components: {
    Loading,
    swiper, 
    swiperSlide
  },
  data () {
    return {
      el: null,
      nowScene: 0,
      initDialog: true,
      isTitle: true,
      phoneTypes: ['通話', '不在着信', '応答なし'],
      phoneImage: [
        'mdi mdi-phone-in-talk mdi-24px',
        'mdi mdi-phone-outgoing mdi-24px',
        'mdi mdi-phone-missed mdi-24px'
      ],
      nowScroll: 0,
      sessionid: null,
      idxRead: -1,
      openScene: 0,
      tempScene: null,
      timeoutId: null,
      isScroll: false,
      isOver: false,
      isFinished: false,
      inputMyName: null,
      isMyName: false,
      isAlreadyGood: false,
      isModalImage: false,
      tempImage: null,
      timeoutNaviID: null,
      timeoutWheelId: null,
      timeoutSwipeId: null,
      isNavi: false,
      isStartView: false,
      pushCount:0,
      isPush:false,
      isAutomatic:false,
      isOnce: '',
      set: null,
      isModal:false,
      isModal2:false,
      isNewsIcon:0,
      isNewsIconPre:0,
      isNewsTitle: '',
      isNewsTitlePre: '',
      isNewsText: '',
      isNewsTextPre: '',
      swiperOption: {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: true,
          loop: true,
          loopFillGroupWithBlank: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
      },
      isModalFlg: false,
      userLoginFlg: false,
      clientLoginFlg: false,
      wantToMeetFlg: false,
      applicationType: -1,
      finishReadingReport: '',
      question: '',
      nextFinishReadingFlg: false,
      nextQuestionFlg: false,
      sendFinishReadingFlg: false,
      sendQuestionFlg: false,
      deltaY: 0,
      tsY: 0,
      teY: 0,
      isWheelAndSwipe: false,
      isChangeScene: false,
      lastView: null, //閲覧履歴
      inputQuizResName: '',
      quizRespondent: null, //クイズ集計用
    }
  },
  computed: {
    ...mapState('auth', ['user', 'isUser', 'isClient', 'token', 'followState']),
    ...mapState('chatbot', ['story', 'storyDialog', 'characters', 'scenes', 'isStoryLoading', 'nextPubStory', 'isGetPubStory', 'otherStories', 'isCompletedStory']),
    ...mapState('mediapool', ['orgImages', 'isImageLoading'])
  },
  mounted () {
    setTimeout(() => {
      this.$store.dispatch('auth/getAccountDetailsUser')
      this.$store.dispatch('mediapool/getStoryOrgImages', this.$route.params.storyid)
      this.$store.dispatch('chatbot/getPubStory', {cid: this.$route.params.companyid, id: this.$route.params.storyid})
      this.createPVStory()
    }, 2000)
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('wheel', this.handleNextView)
    window.addEventListener("touchstart", this.handleSwipeStartView, false)
    window.addEventListener("touchmove", this.handleSwipeMoveView, false)
    window.addEventListener("touchend", this.handleSwipeNextView)
    this.sessionid = localStorage.getItem('SID_' + this.$route.params.companyid)
    this.isAlreadyGood = localStorage.getItem('isgv_' + this.$route.params.storyid) == 'true'
    if (this.isMobile()) this.swiperOption.slidesPerView = 1
    this.getFollowState()
    setTimeout(() => {
      this.lastView = localStorage.getItem('storylv_' + this.$route.params.storyid)
      this.inputMyName = localStorage.getItem('storyName_' + this.$route.params.storyid)
      if (this.lastView) {
        this.lastView = JSON.parse(this.lastView)
        if (this.story && Date.parse(this.story.updated_at) > Date.parse(this.lastView.date)) {
          this.lastView = null
        }
      }
    }, 2000)
    this.quizRespondent = JSON.parse(localStorage.getItem('respondent'))
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('wheel', this.handleNextView)
  },
  watch: {
    characters () {
      for (let i in this.characters) {
        if (this.characters[i].name == '@myname') this.isMyName = true
      }
    },
    story () {
      // 前回の閲覧の後にシナリオが更新された
      if (this.lastView && Date.parse(this.story.updated_at) > Date.parse(this.lastView.date)) {
        this.lastView = null
      }
    },
    storyDialog () {
      // 初手次のノベルの時
      if (this.storyDialog[0].status == 4) this.$store.dispatch('chatbot/getNextPubStory', this.storyDialog[0].content)
      
      // クイズの場合、選択肢をランダムに並べる
      for (let index in this.storyDialog) {
        if (this.storyDialog[index].status == 7) {
          let num = this.storyDialog[index].quiz_choices.length
          let seq = [...Array(num).keys()]
          for (let i=num; i>0; i--) {
            let idx = Math.floor(Math.random() * i)
            seq.push(seq.splice(idx,1))
          }
          this.$set(this.storyDialog[index], 'sequence', seq)
          this.$set(this.storyDialog[index], 'select', null)
        }
      }
    },
    idxRead () {
      // 5秒後にナビ再表示
      clearTimeout(this.timeoutNaviID)
      this.timeoutNaviID = setTimeout(() => {
        this.isNavi = true
      }, 5000)
    },
    isGetPubStory () {
      if (!this.isGetPubStory) this.scrollDown(false, this.openScene)
    }
  },
  methods: {
    beforeEnter: function () {
      console.log('before-enter')
    },
    enter: function () {
      console.log('enter')
    },
    afterEnter: function () {
      console.log('after-enter')
      setTimeout(() => {this.$store.dispatch('chatbot/loadingEnd')}, 1500)
    },
    enterCancelled: function () {
      console.log('enter-cancelled')
    },
    beforeLeave: function () {
      console.log('before-leave')
    },
    leave: function () {
      console.log('leave')
    },
    afterLeave: function () {
      console.log('after-leave')
    },
    leaveCancelled: function () {
      console.log('leave-cancelled')
    },
    isMobile () {
      console.debug('*** Start *** isMobile')
      if (window.navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)) return true
      else return false
    },
    scrollDown (flg, id) {
      var target = document.querySelector('div#scene-' + id + ' div.balloon-list')
      if (!this.isChangeScene && !this.isFinished) {
        if (target) {
          if (flg) this.$nextTick(() => {target.scrollTop = 0})
          else this.$nextTick(() => {target.scrollTop = target.scrollHeight})
        }
      }
      if (this.isFinished) {
        console.log('read LAST')
        let scrollLine = document.getElementById('finished')
        if (scrollLine) {
          var startTime = new Date().getTime()
          var endTime = new Date().getTime() + 1500
          var delta = scrollLine.getBoundingClientRect().top - window.pageYOffset - 200
          var deltaVal = delta / (endTime - startTime) * 60
          var req
          var lastDelta = scrollLine.getBoundingClientRect().top + window.pageYOffset - 200
          // alert(delta)
          var anime = () => {
            var s = new Date().getTime()
            if (s > endTime || window.pageYOffset >= lastDelta) {
              scrollTo(0, lastDelta)
              cancelAnimationFrame(req)
              return
            }
            scrollBy(0, deltaVal)
            requestAnimationFrame(anime)
          }
          var req = requestAnimationFrame(anime)
        }
      }
    },
    handleScroll (e) {
      if (e.cancelable) {
        if (this.isStoryLoading) {
          e.preventDefault()
        } else {
          this.isScroll = true
          clearTimeout(this.timeoutId)
          this.timeoutId = setTimeout(() => {
            this.isScroll = false
          }, 500)
        }
      }
    },
    handleNextView (e) {
      if (e.cancelable) {
        if (this.isStoryLoading) {
          e.preventDefault()
        } else {
          this.deltaY = e.deltaY
          if (e.deltaY > 20 && !this.isWheelAndSwipe && !this.isMyName) {
            this.isWheelAndSwipe = true
            e.preventDefault()
            this.nextDialog()
            this.timeoutWheelId = setTimeout(() => {
              this.isWheelAndSwipe = false
              this.deltaY = 0
            }, 500)
          }
        }
      }
    },
    handleSwipeStartView (e) {
      if (e.cancelable) {
        if (this.isStoryLoading) {
          e.preventDefault()
        } else {
          e.preventDefault()
          this.tsY = e.touches[0].pageY
        }
      }
    },
    handleSwipeMoveView (e) {
      if (e.cancelable) {
        if (this.isStoryLoading) {
          e.preventDefault()
        } else {
          e.preventDefault()
          this.teY = e.changedTouches[0].pageY
        }
      }
    },
    handleSwipeNextView (e) {
      if (e.cancelable) {
        if (this.isStoryLoading) {
          e.preventDefault()
        } else {
          if ((this.tsY - this.teY) > 60 && (this.tsY - this.teY) < 150 && !this.isWheelAndSwipe && !this.isMyName) {
            e.preventDefault()
            this.isWheelAndSwipe = true
            this.teY = 0
            this.tsY = 0
            this.nextDialog()
            this.timeoutWheelId = setTimeout(() => {
              this.isWheelAndSwipe = false
            }, 500)
          }
        }
      }
    },
    nextNavi () {
      var h = 0
      if (this.teY - this.tsY < 0) {
        h = (this.tsY - this.teY) / 2
        if (h > 200) h = 200
      } else {
        h = this.deltaY * 3
        if (h > 200) h = 200
      }
      return {
        position: 'absolute',
        bottom: h,
        width: '100%',
        height: h + 'px',
        background: 'rgba(0, 0, 0, 0.4)'
      }

    },
    handleScrollScene (id) {
      var target = document.querySelector('div.balloon-list div#novel-scroll-' + id)
      var rect = target.getBoundingClientRect().top
      setTimeout(()=> {
        var dif_rect = target.getBoundingClientRect().top
        if (dif_rect - rect > 1000) {     // ←スクロール量の強さはここの値を変える
          if (id > 0) {
            target.scrollIntoView(false)
          }
        } else if (rect - dif_rect > 1000) {     // ←スクロール量の強さはここの値を変える
          if(this.openScene > id){
            var next_target = document.querySelector('div.balloon-list div#novel-scroll-' + String(id + 1))
            next_target.scrollIntoView()
          }
        }
      }, 500)
    },
    getOwnURL (path) {
      return process.env.OWN_ENDPOINT + path
    },
    getWDTURL (path) {
      return process.env.WDT_ENDPOINT + path
    },
    getBotURL (bot) {
      location.href = process.env.OWN_ENDPOINT + '/recruits/bot/' + bot.group + '/' + bot.bot_id
    },
    getRecruitPageURL (recruit) {
      location.href = process.env.WDT_ENDPOINT + '/recruit/detail/' + recruit.company_id + '/' +  recruit.contents_id
    },
    getLineUrl () {
      return 'http://line.me/R/msg/text/?' + process.env.OWN_ENDPOINT + '/recruits/story/' + this.story.company_id + '/' + this.story.story_id
    },
    getTwitterUrl () {
      var urlHttps = 'https://twitter.com/share?url='
      var urlHttp  = 'http://twitter.com/share?url='
      if (process.env.NODE_ENV === 'development') return urlHttp + process.env.OWN_ENDPOINT + '/recruits/story/' + this.story.company_id + '/' + this.story.story_id
      else return urlHttps + process.env.OWN_ENDPOINT + '/recruits/story/' + this.story.company_id + '/' + this.story.story_id
    },
    getFaceBookUrl () {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + process.env.OWN_ENDPOINT + '/recruits/story/' + this.story.company_id + '/' + this.story.story_id
    },
    getUrllist (str) {
      // nullの場合はそのままリターン
      if (!str) return []
      // "https://"から始まる空白文字(スペース、タブ、改行)以外の文字列を取得する
      // (日本語ドメイン、未URLエンコード文字列などに対応するため)
      //var pat = /(https?:\/\/[\x21-\x7e]+)/g    // ASCII文字のみの場合は左記の正規表現
      var pat = /(https?:\/\/[^\s]+)/g            // URLの終端判定は難しいのでマッチする文字列を最後まで取得
      var list = str.match(pat)
      if(!list) return []
      console.log(list)

      // ASCII文字以外の文字がある場合はURLエンコードする
      for(var i in list){
        // ASCII文字以外を探す
        var multiPat = /[^\x21-\x7e]+/
        var multi = list[i].toString().match(multiPat)
        if (multi != null){
          // 二重エンコードを防ぐために一度デコードしてからエンコードする
          var buf = decodeURI(list[i])
          list[i] = encodeURI(buf)
        }
      }
      return list
    },
    getBackgroundImage (content) {
      var defaultURL = require('@/assets/template/default_recruit.jpg')
      if (content.image && content.is_image_original) {
        return 'url(\"' + content.image + '\") center center no-repeat'
      } else if (content.image_url && !content.is_image_original) {
        return 'url(\"' + content.image_url + '\") center center no-repeat'
      } else {
        return 'url(\"' + defaultURL + '\") center center no-repeat'
      }
    },
    getNextPub (d, type) {
      console.debug('*** Start *** getNextPub')
      for (let n of this.nextPubStory) {
        if (n.story_id == d.content) {
          if (type == 0) return n.title
          else if (type == 1) return n
        }
      }
    },
    subStrMessage (text, len) {
      if (!text) return '-'
      else return text.length < len ? text : text.substring(0, len) + '...'
    },
    nextDialog () {
      // 画像上もしくはリンク上にいる場合はリターン
      if (!this.lastView) {
        if (this.isOver) return
        if (this.isFinished) return
        if (this.isScroll) return
        if (this.isGetPubStory) return
      }
      // クイズが回答されていない場合はリターン
      if (this.storyDialog[this.idxRead]
      && this.storyDialog[this.idxRead].status == 7
      && this.storyDialog[this.idxRead].select == null) return

      this.isModal = false
      this.idxRead ++
      this.isNavi = false
      if (!this.storyDialog[this.idxRead]) {
        this.isFinished = true
        setTimeout(()=> {
          this.scrollDown(false, this.openScene)
        }, 500)
        localStorage.removeItem('storylv_'+this.$route.params.storyid)
        localStorage.removeItem('storyName_' + this.$route.params.storyid)
        return
      }
      // ニュース通知
      if (this.storyDialog[this.idxRead].status == 6) {
        this.isNewsIcon = this.storyDialog[this.idxRead].news_icon
        this.isNewsTitle = this.storyDialog[this.idxRead].content
        this.isNewsText = this.storyDialog[this.idxRead].news_content
        this.isModal = true
        if (this.storyDialog[this.idxRead - 1].status == 6) {
          this.isNewsIconPre = this.storyDialog[this.idxRead - 1].news_icon
          this.isNewsTitlePre = this.storyDialog[this.idxRead - 1].content
          this.isNewsTextPre = this.storyDialog[this.idxRead - 1].news_content
          this.isModal2 = true
        }
      }
      // // 画像の拡大
      // if (this.storyDialog[this.idxRead].status == 2) {
      //   this.openImage(this.storyDialog[this.idxRead].store_image)
      // } else {
      //   this.isModalImage = false
      // }
      this.isModalImage = false
      setTimeout(()=> {this.isModal2 = false}, 500)
      // 次の話へ進む場合は色々取得しつつ表示
      if (this.storyDialog[this.idxRead].status == 4) {
        this.$store.dispatch('chatbot/getNextPubStory', this.storyDialog[this.idxRead].content)
        localStorage.removeItem('storylv_'+this.$route.params.storyid)
        localStorage.removeItem('storyName_' + this.$route.params.storyid)
        if(this.idxRead != this.storyDialog.length - 1) {
          // ストーリーの最後でなければここでリターン
          return
        }
      }
      for (let i in this.scenes) {
        if (this.storyDialog[this.idxRead].scene == this.scenes[i].pk) {
          var read_id = this.idxRead
          if (this.openScene != i) {
            console.log('change')
            this.openScene = i
            this.isChangeScene = true
            this.idxRead--
            this.isScroll = true
            setTimeout(()=> {
              this.isScroll = false
              if(read_id == this.storyDialog.length - 1) {
                if (this.storyDialog[read_id].status == 4) {
                  this.$store.dispatch('chatbot/getNextPubStory', this.storyDialog[read_id].content)
                }
              }
            }, 500)
          }
          setTimeout(() => {
            location.href = '/recruits/story/' + this.$route.params.companyid + '/' + this.$route.params.storyid + location.search + '#scene-' + i
            this.isChangeScene = false
          }, 500)
        }
      }
console.log('##### 13')
      if (!this.isChangeScene && !this.isScroll) this.scrollDown(false, this.openScene)
console.log('##### 14')
      localStorage.setItem('storylv_'+this.$route.params.storyid, JSON.stringify({dialog: this.idxRead, scene: this.openScene, date: Date().toString()}))
      localStorage.setItem('storyName_' + this.$route.params.storyid, this.inputMyName)
console.log('##### 15')
    },
    skipToLastView () {
      // 前回の最後まで移動
      while (this.idxRead != this.lastView.dialog || this.openScene != this.lastView.scene) {
        this.nextDialog()
      }
    },
    clickQuizChoice (s) {
      this.storyDialog[this.idxRead].select = s[0]
      this.$store.dispatch('chatbot/registerStoryQuizAnswer', {
        'respondent_id': this.quizRespondent.id,
        'respondent_name': this.quizRespondent.name,
        'company_id': this.story.company_id,
        'dialog': this.storyDialog[this.idxRead].pk,
        'answer': s[0],
      })
    },
    setRespondent (bool) {
      if (bool) this.quizRespondent = {name: this.inputQuizResName, id: createUUID()}
      else this.quizRespondent = {name: '', id: createUUID()}
      localStorage.setItem('respondent', JSON.stringify(this.quizRespondent))
    },
    getCharacterName (character) {
      for (let i in this.characters) {
        if (this.characters[i].pk == character) {
          return this.characters[i].name != '@myname' ? this.characters[i].name : this.inputMyName
        }
      }
    },
    getIconCharacter (sexType, iconType, src) {
      if (sexType >= 0) return require('@/assets/character/' + iconType + '_' + (sexType == 0 ? 'female.png' : 'male.png'))
      else return src
    },
    getIconCharacterFromDialog (character) {
      for (let i in this.characters) {
        if (this.characters[i].pk == character) {
          return this.getIconCharacter(this.characters[i].sex_type, this.characters[i].icon_type, this.characters[i].character_icon)
        }
      }
    },
    getBackgroundImage (idx) {
      return require('@/assets/scene/' + idx + '.jpg')
    },
    getBackgroundScene (scene) {
      console.debug('*** Start *** getBackgroundScene')
      if (scene.image_ref) {
        // オリジナル画像があればそれを使う
        for (let img of this.orgImages) {
          if (img.pk == scene.image_ref) {
            return img.image_data
          }
        }
      }
      // デフォルト画像から使う
      return require('@/assets/scene/' + scene.scene_type + '.jpg')
    },
    getBackgroundStory (story) {
      console.debug('*** Start *** getBackgroundStory')
      if (story.icon_ref) {
        for (let img of this.orgImages) {
          if (img.pk == story.icon_ref) {
            return img.image_data
          }
        }
      }
      // デフォルト画像から使う
      return require('@/assets/scene/' + story.icon_type + '.jpg')
    },
    openImage (src) {
      let w = document.body.clientWidth
      this.tempImage = src
      this.isModalImage = true
    },
    createGVStory () {
      if (this.isAlreadyGood) return
      else {
        let gvData = {
          story: this.story.story_id
        }
        this.$store.dispatch('chatbot/createGVStory', gvData)
        localStorage.setItem('isgv_' + this.story.story_id, 'true')
        this.isAlreadyGood = true
      }
    },
    createPVStory () {
      if (localStorage.getItem('ispv_' + this.$route.params.storyid) == 'true') return
      else {
        let pvData = {
          story: this.$route.params.storyid
        }
        this.$store.dispatch('chatbot/createPVStory', pvData)
        localStorage.setItem('ispv_' + this.$route.params.storyid, 'true')
      }
    },
    startPush(e){
      this.pushCount = 0
      this.isPush = true
      clearInterval(this.set)
      // e.preventDefault()
      this.set = setInterval(() => {
        if(this.isPush == true){
          this.pushCount += 250
        }
      }, 250)
    },
    finishPush(e){
      clearInterval(this.isOnce)
      this.isAutomatic = false
      this.isPush = false
      // e.preventDefault()
      if(this.pushCount >= 1000){
        this.isAutomatic = true
      }
      this.isOnce = setInterval(() => {
        if(this.isFinished == false && this.isAutomatic == true) {
          this.nextDialog()
        }
      }, 2000)
      this.pushCount = 0
    },
    linkOfficialHp () {
      window.open(this.story.company_url, '_top');
    },
    getIconNews (src) {
      return require('@/assets/news/news' + src + '.png')
    },
    isModalActive (n) {
      this.isModalFlg = true
      this.applicationType = n
    },
    userStoryAction () {
      this.wantToMeetFlg = true
      // commentはnull
      this.$store.dispatch('chatbot/storyUserAction', { story:       this.story.story_id,
                                                        action_type: this.applicationType,
                                                        comment:     null,
                                                        company:     this.story.company_id })
    },
    closeModal () {
      this.isModalFlg = false
    },
    sendFinishReading () {
      this.$store.dispatch('chatbot/storyUserAction', { story:       this.story.story_id,
                                                        action_type: this.applicationType,
                                                        comment:     this.finishReadingReport,
                                                        company:     this.story.company_id })
      this.sendFinishReadingFlg = true
    },
    writeNovel () {
      if (this.$isUser()) {
        window.open('/recruits/story')
      } else if (this.$isClient()) {
        window.open('/dashboard/story')
      } else {
        this.isModalFlg = true
      }
    },
    sendQuestion () {
      this.$store.dispatch('chatbot/storyUserAction', { story:       this.story.story_id,
                                                        action_type: this.applicationType,
                                                        comment:     this.question,
                                                        company:     this.story.company_id })
      this.sendQuestionFlg = true
    },
    postStoryProfileFavorite () {
      this.$store.dispatch('chatbot/postStoryProfileFavorite', { story: this.story.story_id,})
    },
    getFollowState () {
      if (this.$isUser()) {
        this.$store.dispatch('auth/getFollow', this.$route.params.companyid)
      }
    },
    addFollow () {
      this.$store.dispatch('auth/addFollow', [{'company': this.$route.params.companyid}])
    },
    deleteFollow () {
      this.$store.dispatch('auth/deleteFollow', [{'company': this.$route.params.companyid}])
    },
    loginUserCheck () {
      if (localStorage.getItem('IS_USER') == 'true') {
        this.userLoginFlg = true
      } else if (localStorage.getItem('IS_CLIENT') == 'true') {
        this.clientLoginFlg = true
      }
    },
    tagsList (tags) {
      if (tags === null) {
        return []
      } else {
        const arr = tags.split(',')
        arr.pop()
        return arr
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
html, body {
  width: 100vw;
  height: 100vh;
  touch-action: manipulation;
}
.vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: auto;
  padding-bottom: 32px;
}
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.main-body {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: y mandatory;
  -webkit-overflow-scrolling: touch;
  transition: all 1s ease;
}
.header-recruit {
  width: 50%;
  min-width: 720px;
  height: 120px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
  color: white;
  background: transparent;
}
.header-recruit > img {
  width: 100%;
  height: 120px;
  max-height: auto;
  object-fit: cover;
  position: absolute;
  z-index: 0;
  filter: brightness(60%) blur(0.5px);
  background: #eee;
}
.start-container {
  display: block;
  height: auto;
  transition: all 1.1s ease;
  opacity: 0;
  will-change: transform;
}
.init-anime-enter-active {
  transform: translateY(-200%);
  opacity: 1;
}
.init-anime-leave-active {
  opacity: 1;
}
.init-anime-leave-to {
  opacity: 0;
}
.init-anime-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.start-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.start-box > img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  filter: brightness(60%);
}
.init-title {
  width: 50%;
  min-width: 720px;
  height: 60px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  z-index: 1;
}
.title-box {
  width: 50%;
  min-width: 720px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  padding-left: 16px;
  font-size: larger;
  font-weight: 600;
  background: transparent;
  z-index: 1;
  #title {
    padding-top: 5px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    text-align: left;
  }
  .sub-title {
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
  }
}
.title-container > a{
  display: flex;
  color: #FEFEFE;
}
.logo-wrapper > img {
  width: 40px;
  height: auto;
  background: #FEFEFE;
  border-radius: 50%;
}
.logo-title {
  display: flex;
  margin-left: 4px;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
}
.link-nav > ul {
  display: flex;
  align-items: center;
}
.link-nav  button {
  width: 120px;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 16px;
  border: 1px solid #dbdbdb;
}
.link-nav  a {
    font-weight: bold;
}
.link-nav  p {
    color: #EE2C98;
}
.login-btn {
    background-color: #fff;
    color: #EE2C98;
    cursor: pointer;
}
.register-btn {
  background-color: #EE2C98;
  color: #fff;
  border: none;
  cursor: pointer;
}
.flex-container {
  width: 50%;
  min-width: 720px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.main-container {
  scroll-behavior: smooth;
  overflow: scroll;
  position: relative;
  height: 100vh;
  scroll-snap-type: y mandatory;
  -webkit-overflow-scrolling: touch;
  transition: all 1s ease;
}
.fade-enter-active {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.scene-container {
  position:relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  scroll-snap-align: start;
}
.scene-container > img {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  filter: brightness(60%);
}
.balloon-list {
  height: 100%;
  width: 100%;
  margin-top: 8px;
  padding: 16px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  position: relative;
}
.balloon-list::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  visibility: hidden;
}
.dialog-box {
  position: relative;
  padding-top: 8px;
}
.dialog-box:hover {
  background: rgba(200, 200, 200, 0.3);
}
.dialog-box > button {
  color: white;
}
.dialog-box > .left-button {
  left: 8px;
}
.bln-box {
  display: flex;
  width: 100%;
  margin-bottom: 16px;
}
.bln-box > img {
  z-index:100;
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  background: #eee;
  z-index: 1;
}
.message-box, .message-box-title {
  margin-bottom: 16px;
  /* min-height: 64px; */
  .font-small {
    font-size: 16px;
  }
  .font-medium {
    font-size: 20px;
  }
  .font-large {
    font-size: 24px;
    font-weight: bold;
  }
}
.message-box {
  text-align: right;
  margin-right: 16px;
  width: calc(100% - 62px);
}
.message-box-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.message-box > .name {
  color: #f8f8f8;
  font-size: smaller;
  text-align: left;
  font-weight: 600;
  margin-left: 6px;
}
.message-box > .message {
  display: block;
  width: fit-content;
  resize: none;
  font-size: 18px;
  height: auto;
  padding: 0.5em 0.8em;
  border-radius: 8px;
  border: none;
  text-align: left;
  background: #FEFEFE;
  color: #111;
  white-space: pre-line;
  word-break: break-all;
  margin-top:4px;
  margin-left: -6px;
}
.message-box-title > p {
  display: block;
  width: 90%;
  resize: none;
  font-size: 18px;
  height: auto;
  padding: 8px;
  border: none;
  background: rgb(252, 252, 252);
  text-align: center;
  white-space: pre-line;
}
.message-box > .message-box-image {
  transition: 0.2s;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  margin-top:6px;
  margin-left: -8px;
  max-height: 300px;
  max-width: calc(100% - 20px);
}
.message-box > .message-box-image > img {
  max-height: 300px;
  max-width: calc(100% - 20px);
  display: flex;
  object-fit: cover;
}
.message-box > .no-image {
  border-radius: 4px;
  background: #222222cc;
  color: #fefefe;
  width: 256px; height: 96px;
  padding: 8px;
  display: flex; justify-content: center; align-items: center;
  margin: 0 0 0 auto;
}
.my-speaker {
  justify-content: end;
  flex-direction: row-reverse;
}
.my-speaker > .message-box > .name {
  text-align: end;
  margin-left: 0;
  margin-right: -10px;
}
.my-speaker > .message-box > img {
  float: right;
}
.my-speaker > .message-box > .message {
  background: #ADDB67 !important;
  color: #222 !important;
  float: right;
  margin-top:4px;
  margin-right: -20px;
  z-index:-100;
}
.my-speaker > .message-box > .message-box-image {
  margin-left:40px;
  margin-right:-40px;
}
.no-speaker {
  justify-content: center;
  align-items: center;
}
.parts-box {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  background: rgba(222, 232, 222, 0.8);
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 4px;
}
.parts-box > .parts {
  width:  54px;
  height: 54px;
  margin: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #eef;
  font-size: xx-small;
  cursor: pointer;
}
.phone-box {
  width:  54px;
  height: 54px;
  margin: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #eef;
  color: #222;
  font-size: xx-small;
  cursor: pointer;
}
.my-speaker > .message-box > .phone-box {
  float:right;
  margin-right:-12px;
}
.character-box {
  width: 100px;
  height: 100px;
  margin: 8px;
  background: #fee;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.character-box > p {
  width: 80%;
  border: none;
  background: #FEFEFE;
  border-radius: 0;
  margin-top: 4px;
}
.next-box {
  width: 100%;
  height: 150px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FEFEFE;
  color: white;
  flex-direction: column;
}
.next-box > .next-img {
  width: 100%;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.next-box > .next-img > img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  position: absolute;
  filter: brightness(60%) blur(0.5px);
  top: 0;
  left: 0;
  z-index: 0;
}
.next-box > p {
  z-index: 1;
  padding: 16px;
}
.next-box > a {
  z-index: 1;
  padding: 8px;
  width: 80%;
  word-break: break-word;
  white-space: pre-wrap;
  height: auto;
  font-size: smaller;
}
.close-button {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  border: none;
  padding: 0;
}
.chat-button {
  width: 36px;
  height: 36px;
  position: absolute;
  left: 0;
  top: 0;
  background: transparent;
  border: none;
  padding: 0;
}
.app-button {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 0;
  top: 54px;
  background: transparent;
  border: none;
  padding: 0;
}
.button-story {
  background: rgba(0, 0, 0, 0.7);
  color: #f8f8f8;
  border-radius: 16px;
}
.scene-list {
  position: absolute;
  right: 0;
  min-width: 300px;
  width: 50%;
  background: #f0f0f0;
  height: 100%;
  z-index: 10;
  padding: 16px;
}
.scene-list-modal {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9;
}
.scene-list > p {
  margin-bottom: 8px;
  font-weight: 600;
}
.scene-list > button {
  margin-top: 8px;
  width: 100%;
}
.scene-box {
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 8px;
}
.scene-box > img {
  width: 100%;
  height: 80px;
  max-height: auto;
  object-fit: cover;
  filter: brightness(50%) blur(1px);
}
.scene-inner {
  position: absolute;
  left: 0; top: 0;
  width: 100%;
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}
.scene-inner > p {
  font-size: larger;
  font-weight: 600;
  width: calc(100% - 264px);
  color: white;
  text-align: left;
  padding-left: 16px;
}
.scene-inner > .set {
  font-size: medium;
  font-weight: 600;
  margin-right: 8px;
  height: calc(100% - 8px);
  width: 80px;
  background: transparent;
  color: white;
  border: solid thin #aae;
}
.scene-inner > .change {
  font-size: medium;
  font-weight: 600;
  margin-right: 8px;
  height: calc(100% - 8px);
  width: 80px;
  background: transparent;
  color: white;
  border: solid thin #aea;
}
.scene-inner > .del {
  font-size: medium;
  font-weight: 600;
  margin-right: 8px;
  height: calc(100% - 8px);
  width: 80px;
  background: transparent;
  color: white;
  border: solid thin #eaa;
}
.share-container {
  width: 50%;
  height: auto;
  background: #ffeeee;
  min-width: 720px;
  display: flex; justify-content: center; align-items: center; flex-direction: column;
  padding: 16px;
  margin: auto;
  margin-top: 16px;
  margin-bottom: 16px;
}
.good-button {
  position: relative;
  height: 80px; width: 80px; 
  display: flex; justify-content: center; align-items: center;
  color: red;
  flex-direction: column;
  border: solid 2px #f29;
  background: #fef;
  cursor: pointer;
  border-radius: 50%;
  margin-top: 8px;
  margin-bottom: 8px;
}
.last-view {
  position: absolute;
  z-index: 1;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  color: white;
  font-weight: 600;
}
.last-view-button {
  position: absolute;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}
.tap-navi {
  height: 80%;
  width: 100%;
  z-index: 1;
  position: relative;
}
.tap-navi > p {
  color: white;
  font-weight: 600;
}
.tap-navi > div {
  color: white;
}
.tap-navi > .auto-button {
  border-radius: 16px;
  position: absolute;
  bottom: 70px;
  right: 16px;
  border: none;
}
/* modal */
.modal-myname {
  position: fixed;
  width: 300px;
  height: 200px;
  top: calc(50% - 200px/2);
  left: calc(50% - 300px/2);
  z-index: 4;
  background: #fefefe;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}
.modal-respondent {
  position: fixed;
  width: 300px;
  height: 200px;
  top: calc(50% - 200px/2);
  left: calc(50% - 300px/2);
  z-index: 4;
  background: #fefefe;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
/* animation */
.slide-top-enter-active, .slide-top-leave-active {
  transform: translateY(0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.slide-top-enter {
  transform: translateY(-100px);
}
.slide-top-leave-to {
  transform: translateY(-100px);
}
/* dot */
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  z-index: 1;
}
/* 上下に浮遊 */
.huyuu {
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}

/*ノベル*/
.novel-card {
  font-size:14px;
  text-align: left;
  color:black;
  padding: 16px;
  width: 60%;
  border: solid #cecece 0.5px;
  border-top:none;
  border-right:none;
  border-left:none; 
  display: flex;
  align-items: center;
  section {
    width: 50%;
  }
}
.novel-card.active {
    border-top: solid #cecece 0.5px;
    margin-top:20px;
}
.novel-card:hover{
  background: #d3d1d1;
  transform: scale(1.03);
  transition: 0.2s;
}
.img-icon {
  display: flex;
  align-items: center;
  width: 40%;
  height: 120px;
  margin-right: 16px;
}
.img-icon img{
  border-radius: 10px;
  max-height: 120px;
}
.novel-title{
  width: 100%;
  font-size: larger;
  display: block; text-overflow: ellipsis; white-space: nowrap; width: auto; max-width: 100%; overflow: hidden;
}
.novel-company{
  font-size: 12px;
  padding-top :4px;
}
.novel-create{
  font-size: 12px;
  margin-top: 4px;

}
.img-icon img {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}
.anotherNovel {  
  height: auto;
  min-width: 80%;
  max-width: 80%;
  display: flex; justify-content: center; align-items: center; flex-direction: column;
  padding: 10px 0;
  margin-bottom: 16px;
}
.anotherNovel h1 {
  position: relative;
  font-size: x-large;
}
.anotherNovel h1:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 7px;
  background: -webkit-repeating-linear-gradient(-45deg, #EE2B98, #EE2B98 2px, #fff 2px, #fff 4px);
  background: repeating-linear-gradient(-45deg, #EE2B98, #EE2B98 2px, #fff 2px, #fff 4px);
}
.movie-container {
  display: contents;
  text-align: right;
  .no-image {
    border-radius: 4px;
    background: #222222cc;
    color: #fefefe;
    width: 256px; height: 96px;
    padding: 8px;
    display: flex; justify-content: center; align-items: center;
    margin: 0 0 0 auto;
  }
}
.video-style{
  float:left;
  margin-top:6px;
  margin-left:4px;
}
.my-speaker > .message-box > .movie-container > .video-style {
  float:right;
  margin-right:-10px;
}
.news-container {
  position:absolute;
  margin:0 10%;
  z-index:9998;
  border-radius: 10px;
  background-color: rgb(241, 235, 235);
  display: grid;
  grid-template-columns: 20% 80%;
  grid-template-rows: 70px 70px;
  grid-template-areas: "news-img news-title" "news-text news-text";
  height:140px;
  width: 80%;
  border-radius: 10px;
  top:20px;
}
.news-container2 {
  position:absolute;
  margin:0 10%;
  z-index:9998;
  border-radius: 10px;
  background-color: rgb(241, 235, 235);
  display: grid;
  grid-template-columns: 20% 80%;
  grid-template-rows: 70px 70px;
  grid-template-areas: "news-img news-title" "news-text news-text";
  height:140px;
  width: 80%;
  border-radius: 10px;
  top:170px;
}
.news-img {
  grid-area: news-img;
  padding:10px 10px 10px 20px;
}
.news-img img{
  height: 100%;
  border:solid black 1px;
  border-radius: 10px; 
}
.news-text{
  grid-area: news-text;
  border: none;
  resize:none;
  margin:0 50px 0 50px;
  padding: 0.5em;         
  width: calc(100% - 100px); 
  font-size: 1em;        
  line-height: 1.2;       
  background-color:rgb(241, 235, 235);
  text-align:left;
}
.news-title{
  grid-area: news-title;
  font-weight:bold;
  border: none;
  resize:none;
  padding: 0.5em;          
  width: calc(100% - 10px);           
  font-size: 17px;          
  line-height: 1.2;       
  background-color:rgb(241, 235, 235);
  text-align:left;
  margin-top:15px;
}
.news-enter{
  opacity: 0;
  transform: translateY(-20px);
}
.news-enter-active {
  transition: opacity 300ms ease-out, transform 300ms ease-out;
}
.news-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
.news-leave-active{
  transition: opacity 300ms ease-out, transform 300ms ease-out;
}
.quiz-box {
  display: block;
  width: 100%;
  margin-bottom: 16px;
}
.quiz-question {
  display: block;
  width: 90%;
  resize: none;
  font-size: 18px;
  height: auto;
  border-radius: 8px;
  border: none;
  background: #FEFEFE;
  color: #111;
  margin-top: 4px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 3px;
  p {
    padding-top: 5px;
    padding-bottom: 5px;
    white-space: pre-line;
    word-break: break-all;
  }
}
.quiz-choice {
  display: flex;
  position: relative;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-size: 18px;
  margin-bottom: 3px;
  .sign {
    width: 30px;
    height: 100%;
    margin-right: 10px;
  }
  .statement {
    width: calc(100% - 30px);
  }
}
.quiz-collect:disabled {
  background-color: lightpink;
  color: black;
}
.quiz-incollect:disabled {
  background-color: #99BBDD;
}
.quiz-select:disabled {
  border: ridge 3px black;
}
.card {
  padding: 32px;
  border-radius: 5px;
}
.email-wrapper, .password-wrapper  {
  margin-top: 16px;
  text-align: left;
  p {
    font-size: 12px;
    margin-bottom: 8px;
  }
}
.login-btn-wrapper {
  margin-top: 40px;
}
.create-account {
  margin-top: 24px;
}
.entry {
  font-weight: bold;
}
.entry-msg {
  margin-top: 24px;
  font-weight: bold;
  font-size: 24px;
  color: #AA0066;
}
.entry-sub-msg {
  margin-top: 16px;
  text-align: left;
}
.button-wrapper {
  .button {
    margin-top: 24px;
    width: 160px;
  }
}
$title-color: (
  'black': black,
  'white': white,
  'red': red,
  'orange': orange,
  'yellow': yellow,
  'green': green,
  'skyblue': skyblue,
  'blue': blue,
  'purple': purple,
);
.novel-tag {
  margin-right: 8px;
  margin-bottom: 2px;
}
@each $colorName, $color in $title-color {
  .font-color-#{$colorName} {
    color: $color;
  }
  .bg-color-#{$colorName} {
    background-color: $color !important;
  }
}
.menu-btn-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .menu-btn {
    width: 240px;
    margin: 8px;
  }
}
.space-top16 {
  margin-top: 16px;
}
.finish-reading {
  font-size: 20px;
  margin-bottom: 16px;
  font-weight: bold;
}
.finish-reading-textarea {
  margin-bottom: 16px;
  padding: 8px;
  border-radius: 8px;
  min-height: 200px;
  border: 1px solid #AA0066;
  text-align: left;
}
.confirm-sentence {
  font-size: 14px;
  margin-bottom: 16px;
  text-align: left;
}
.button-container {
  display: flex;
  justify-content: space-evenly;
  button {
    width: 240px;
  }
}
.top-wrapper {
  display: flex;
  justify-content: space-between;
}
.bottom-wrapper {
  display: flex;
  justify-content: space-between;
}
.novel-tags-container {
  margin-top: 8px;
}

.logo-img-wrapper {
  width: 280px;
  margin: auto;
}
.need-login-msg {
  margin-top: 32px;
  font-size: 14px;
}
.evaluate-btn-container {
  display: flex;
  align-items: center;
}
.add-follow-btn {
  background-color: #ffffff;
  padding: 8px 16px;
  width: 144px;
  border-radius: 6px;
  border: solid 1px #9e9e9e;
  margin-left: 16px;
  font-weight: bold;
}  
.delete-follow-btn {
  background-color: #65DFE1;  padding: 8px 16px;
  width: 144px;
  border-radius: 6px;
  margin-left: 16px;
  font-weight: bold;
  color: #ffffff;
}
/* mobile */
@media screen and (max-width: 800px) {
  .header-recruit {
    width: 100%;
    min-width: 100%;
    height: 96px;
  }
  .header-recruit > img {
    width: 100%;
    height: 96px;
  }
  .init-title {
    width: 100%;
    min-width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .start-container {
    width: 100%;
    min-width: 100%;
    height: 100%;
  }
  .title-box {
    width: 100%;
    min-width: 100%;
    height: 100%;
  }
  .logo-title {
    display: none;
    font-size: 12px;
  }
  .link-nav p {
    display: none;
    font-size: 10px;
  }
  .link-nav button {
    width: 60px;
    height: 25px;
    font-size: 10px;
  }
  .flex-container {
    width: 100%;
    min-width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .share-container {
    width: 100%;
    min-width: 100%;
    height: auto;
  }
  .thanks-message {
    font-size: smaller;
  }
  .anotherNovel h1 {
    position: relative;
    font-size: larger;
  }
  .anotherNovel h1:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3.5px;
    background: -webkit-repeating-linear-gradient(-45deg, #EE2B98, #EE2B98 2px, #fff 2px, #fff 4px);
    background: repeating-linear-gradient(-45deg, #EE2B98, #EE2B98 2px, #fff 2px, #fff 4px);
  }
  .novel-card{
    padding: 8px;
    width:100%;
  }
  .novel-title{
    font-size:15px;
  }
  .novel-company{
    font-size:10px;
  }
  .novel-create{
    font-size:10px;
  }


  .news-container {
    grid-template-columns: 20% 80%;
    grid-template-rows: 45px 55px;
    height:100px;
  }
  .news-container2 {
    grid-template-columns: 20% 80%;
    grid-template-rows: 45px 55px;
    height:100px;
    top:130px;
  }

  .news-img {
    padding:7px 5px 5px 10px;
  }
  .news-img img{
    border-radius: 5px; 
  }

  .news-text{
    width: calc(100% - 40px);  
    font-size:12px;
    margin:0 20px 0 20px;
  }

  .news-title{
    font-size:12px;
    margin-top:5px;
  }
  .modal-window {
    width: 400px;
    height: 400px;
    background-color: white;
  }
  .top-wrapper, .bottom-wrapper {
    display: block;
  }
  .menu-btn-container{
    justify-content: center;
  }
  .button-wrapper {
    .button {
      margin-top: 24px;
      width: 120px;
    }
  }
  .button-container {
    button {
      width: 120px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ChatSinglePage/StoryView.vue